import Banner from 'components/Banner';
import CareerForm from 'components/FormSection/Forms/CareerForm';
import JobLabels from 'components/JobLabels';
import TextWithIcon from 'components/TextWithIcon';
import React from 'react';
import { useParams } from 'react-router-dom';
import { fetchJob } from 'store/getJobsSlice';
import { useDispatch, useSelector } from 'react-redux';

const DetailedJob = () => {
    const { slug } = useParams();
    const dispatch = useDispatch();
    // @ts-ignore
    const { jobs } = useSelector(state => state?.jobsState);

    const currentJob = jobs?.[slug];

    React.useEffect(() => {
        dispatch(
            // @ts-ignore
            fetchJob({
                language: 'en',
                country: 'en',
                slug,
            }),
        );
    }, [dispatch, slug]);

    const { title, data, experience, locations, work_type, title_background } = currentJob || {};

    return (
        <>
            <Banner image={title_background} buttonText="Apply for a job">
                <h2>{title}</h2>
                <JobLabels experience={experience} locations={locations} work_type={work_type} />
                <TextWithIcon iconName="calendar" text={'!!add date'} />
            </Banner>

            <article className="article-content" dangerouslySetInnerHTML={{ __html: data }} />

            <CareerForm />
        </>
    );
};

export default DetailedJob;
